import getConfig from "next/config";

export { brandCodes, brandRegionCodes, regionCodes } from "./brandRegionConfig";

// ! REMEMBER TO UPDATE next.config.js WHEN ADDING publicRuntimeConfig VARIABLES
const { publicRuntimeConfig, serverRuntimeConfig } = getConfig() || {};
export const environment = process.env.NODE_ENV;
export const isProduction = process.env.NODE_ENV === "production";
export const isDevelopment = process.env.NODE_ENV === "development";
export const isBrowser = typeof window !== "undefined";
export const isSecureWindowContext =
  typeof window !== "undefined" && window.isSecureContext;
export const isMSWEnabled =
  publicRuntimeConfig?.NEXT_PUBLIC_API_MOCKING === "enabled"; // default disabled

export const CENTRIX_URL =
  publicRuntimeConfig?.CENTRIX_URL || process.env.NEXT_PUBLIC_CENTRIX_URL;

export const API_URL =
  publicRuntimeConfig?.API_URL || process.env.NEXT_PUBLIC_API_URL;

export const IDS_URL =
  publicRuntimeConfig?.IDS_URL || process.env.NEXT_PUBLIC_IDS_URL;

export const APPLICATIONINSIGHTS_CONNECTION_STRING =
  publicRuntimeConfig?.APPLICATIONINSIGHTS_CONNECTION_STRING ||
  process.env.APPLICATIONINSIGHTS_CONNECTION_STRING;

export const GOOGLE_EMBED_API_KEY =
  publicRuntimeConfig?.GOOGLE_EMBED_API_KEY ||
  process.env.NEXT_PUBLIC_GOOGLE_EMBED_API_KEY;

export const SUPPORT_EMAIL =
  publicRuntimeConfig?.SUPPORT_EMAIL || process.env.NEXT_PUBLIC_SUPPORT_EMAIL;

export const NPS_REDIRECT_URL =
  publicRuntimeConfig?.NPS_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_NPS_REDIRECT_URL;

export const V7_REDIRECT_URL =
  publicRuntimeConfig?.V7_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_V7_REDIRECT_URL;

export const V7_PROC_REDIRECT_URL =
  publicRuntimeConfig?.V7_PROC_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_V7_PROC_REDIRECT_URL;

export const V7_CRE_REDIRECT_URL =
  publicRuntimeConfig?.V7_CRE_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_V7_CRE_REDIRECT_URL;

export const SPEEDYAUTO_REDIRECT_URL =
  publicRuntimeConfig?.SPEEDYAUTO_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_SPEEDYAUTO_REDIRECT_URL;

export const NOVUSGLASS_REDIRECT_URL =
  publicRuntimeConfig?.NOVUSGLASS_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_NOVUSGLASS_REDIRECT_URL;

export const FIXAUTO_REDIRECT_URL =
  publicRuntimeConfig?.FIXAUTO_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_FIXAUTO_REDIRECT_URL;

export const NPS_CRE_REDIRECT_URL =
  publicRuntimeConfig?.NPS_CRE_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_NPS_CRE_REDIRECT_URL;

export const NPS_FIXAUTO_REDIRECT_URL =
  publicRuntimeConfig?.NPS_FIXAUTO_REDIRECT_URL ||
  process.env.NEXT_PUBLIC_NPS_FIXAUTO_REDIRECT_URL;

export const REVALIDATE_IF_STALE =
  publicRuntimeConfig?.REVALIDATE_IF_STALE !== "false"; // default true

export const SANITIZE_CMS_CONTENT =
  publicRuntimeConfig?.SANITIZE_CMS_CONTENT !== "false"; // default true

export const MUI_X_LICENSE =
  publicRuntimeConfig?.NEXT_PUBLIC_MUI_X_LICENSE ||
  process.env.NEXT_PUBLIC_MUI_X_LICENSE;

export const RECAPTCHA_SITE_KEY =
  publicRuntimeConfig?.NEXT_PUBLIC_RECAPTCHA_SITE_KEY ||
  process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;

export const DEFAULT_DEV_BRAND_CODE =
  publicRuntimeConfig?.NEXT_PUBLIC_DEFAULT_DEV_BRAND_CODE ||
  process.env.NEXT_PUBLIC_DEFAULT_DEV_BRAND_CODE;

export const AUTHORIZE_DOTNET_CLIENT_KEY =
  publicRuntimeConfig?.NEXT_PUBLIC_AUTHORIZE_DOTNET_CLIENT_KEY ||
  process.env.NEXT_PUBLIC_AUTHORIZE_DOTNET_CLIENT_KEY;

export const AUTHORIZE_DOTNET_API_LOGIN_ID =
  publicRuntimeConfig?.NEXT_PUBLIC_AUTHORIZE_DOTNET_API_LOGIN_ID ||
  process.env.NEXT_PUBLIC_AUTHORIZE_DOTNET_API_LOGIN_ID;

export const AUTHORIZE_DOTNET_ENVIRONMENT =
  publicRuntimeConfig?.NEXT_PUBLIC_AUTHORIZE_DOTNET_ENVIRONMENT ||
  process.env.NEXT_PUBLIC_AUTHORIZE_DOTNET_ENVIRONMENT;

export const ROYALTY_PAYMENT_SHOW_LOCATION =
  publicRuntimeConfig?.NEXT_PUBLIC_ROYALTY_PAYMENT_SHOW_LOCATION === "true" ||
  process.env.NEXT_PUBLIC_ROYALTY_PAYMENT_SHOW_LOCATION === "true";

export const LOGO_BASE_URL =
  publicRuntimeConfig?.NEXT_PUBLIC_LOGO_BASE_URL ||
  process.env.NEXT_PUBLIC_LOGO_BASE_URL ||
  "";

export const ROYALTY_PAYMENT_ENABLED =
  publicRuntimeConfig?.NEXT_PUBLIC_ROYALTY_PAYMENT_ENABLED === "true" ||
  process.env.NEXT_PUBLIC_ROYALTY_PAYMENT_ENABLED === "true";

export const HTML_EDITOR_IMAGE_UPLOAD_ENABLED =
  publicRuntimeConfig?.NEXT_PUBLIC_HTML_EDITOR_IMAGE_UPLOAD_ENABLED ===
    "true" ||
  process.env.NEXT_PUBLIC_HTML_EDITOR_IMAGE_UPLOAD_ENABLED === "true";

export const GEOCODE_API_KEY =
  serverRuntimeConfig?.GEOCODE_API_KEY || process.env.GEOCODE_API_KEY;

export const MSAL_CONFIG = {
  authority:
    publicRuntimeConfig?.NEXT_PUBLIC_MSAL_AUTHORITY ||
    process.env.NEXT_PUBLIC_MSAL_AUTHORITY,
  clientId:
    publicRuntimeConfig?.NEXT_PUBLIC_MSAL_CLIENT_ID ||
    process.env.NEXT_PUBLIC_MSAL_CLIENT_ID,
  redirectUri:
    publicRuntimeConfig?.NEXT_PUBLIC_MSAL_REDIRECT_URI ||
    process.env.NEXT_PUBLIC_MSAL_REDIRECT_URI,
};

export const SHAREPOINT_URL =
  publicRuntimeConfig?.NEXT_PUBLIC_SHAREPOINT_URL ||
  process.env.NEXT_PUBLIC_SHAREPOINT_URL;

export const DEFAULT_NEWS_TYPE_ID =
  publicRuntimeConfig?.NEXT_PUBLIC_DEFAULT_NEWS_TYPE_ID ||
  process.env.NEXT_PUBLIC_DEFAULT_NEWS_TYPE_ID ||
  "";

export const DEFAULT_NEWS_CATEGORY_ID =
  publicRuntimeConfig?.NEXT_PUBLIC_DEFAULT_NEWS_CATEGORY_ID ||
  process.env.NEXT_PUBLIC_DEFAULT_NEWS_CATEGORY_ID ||
  "";

export const DEFAULT_EVENT_TYPE_ID =
  publicRuntimeConfig?.NEXT_PUBLIC_DEFAULT_EVENT_TYPE_ID ||
  process.env.NEXT_PUBLIC_DEFAULT_EVENT_TYPE_ID ||
  "";

export const DEFAULT_EVENT_CATEGORY_ID =
  publicRuntimeConfig?.NEXT_PUBLIC_DEFAULT_EVENT_CATEGORY_ID ||
  process.env.NEXT_PUBLIC_DEFAULT_EVENT_CATEGORY_ID ||
  "";

const FINANCE_DOWNLOAD_EXCLUDE_PREFIXES_RAW =
  publicRuntimeConfig?.NEXT_PUBLIC_FINANCE_DOWNLOAD_EXCLUDE_PREFIXES ||
  process.env.NEXT_PUBLIC_FINANCE_DOWNLOAD_EXCLUDE_PREFIXES ||
  "";

export const FINANCE_DOWNLOAD_EXCLUDE_PREFIXES =
  typeof FINANCE_DOWNLOAD_EXCLUDE_PREFIXES_RAW !== "string" ||
  FINANCE_DOWNLOAD_EXCLUDE_PREFIXES_RAW === "null"
    ? []
    : (FINANCE_DOWNLOAD_EXCLUDE_PREFIXES_RAW.split(",").filter(
        Boolean
      ) as string[]);
